.carousel-container {
    position: relative;
    height: 80px;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pill {
    position: absolute;
    padding: 8px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    border-radius: 8px;
    background: white;
    width: fit-content;
    white-space: nowrap;
    opacity: 0;
    --vertical-offset: 45px;
    --smaller-scale: 0.8;
    transform: translateY(var(--vertical-offset)) scale(var(--smaller-scale));
    animation: pillRotate var(--total-duration) ease-in-out infinite;
    animation-delay: var(--animation-delay);
}

@keyframes pillRotate {
    0%,
    16% {
        opacity: 0;
        transform: translateY(calc(var(--vertical-offset) * -1)) scale(var(--smaller-scale));
    }
    20%,
    36% {
        opacity: 0.6;
        transform: translateY(calc(var(--vertical-offset) * -1)) scale(var(--smaller-scale));
    }
    40%,
    56% {
        opacity: 1;
        transform: translateY(0) scale(1);
        z-index: 1;
    }
    60%,
    76% {
        opacity: 0.6;
        transform: translateY(var(--vertical-offset)) scale(var(--smaller-scale));
    }
    80%,
    100% {
        opacity: 0;
        transform: translateY(var(--vertical-offset)) scale(var(--smaller-scale));
    }
}
